import { ChangeDetectionStrategy, Component, OnInit, Signal, computed, signal } from '@angular/core';
import { EmptyApiObject } from 'api/api-models';
import { UserApi } from 'api/user/user-api.js';
import { map } from 'rxjs';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';

type EmailConfirmState = 'unknown' | 'confirmed';

@Component({
    templateUrl: './confirm-email.component.html',
    selector: 'mod-confirm-email',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmEmailComponent extends CoreAppComponent implements OnInit {
	public readonly malformedRequest: Signal<boolean> = computed(() => {
		if (this.form.userId()) {
			return false;
		}

		return true;
	});

	private readonly userIdQueryString: string = 'user';
	public readonly loginRouterLink: string = this.dependencies.navigateService.loginPage().getUrl();

	public readonly emailConfirmState = signal<EmailConfirmState>('unknown');

	public readonly form = {
		userId: signal<string | undefined>(undefined)
	};

	constructor() {
		super();
	}

	ngOnInit(): void {
		const userId = super.getQueryStringValue(this.userIdQueryString);
		this.form.userId.set(userId);

		if (userId) {
			this.confirmEmail(userId);
		}
	}

	private confirmEmail(userId: string): void {
		super.subscribeToObservable(
			this.dependencies.httpService
				.post<EmptyApiObject, UserApi.IConfirmEmailRequest>((builder) =>
					builder
						.withCustomApiRoute('user', 'confirmEmail')
						.withData({
							userId: userId
						})
						.build()
				)
				.pipe(
					map((response) => {
						this.emailConfirmState.set('confirmed');
					})
				)
		);
	}
}
